<template>
  <div>
    <slot></slot>    
  </div>
</template>
  
<script>
import _ from 'lodash'
// import Chip from "./Chip.vue"
export default {
 
  props: {
    modelValue: Array,
  },
  data() {
    return {

    }
  },
  computed: {
    chipGroupSelectedValue() {
      return this.modelValue
    }
  },
  methods: {
    onSelectHandler(data) {
      console.log(data)
      const index = this.modelValue.findIndex( v => _.isEqual(data, v))
      let value = []
      if(index < 0) {
        value = [...this.modelValue, data]
      } else {
        value = this.modelValue.filter( v => !_.isEqual(data, v))        
      }
      this.$emit("update:modelValue", value)
      this.$emit("change", value)
    }
  }
}
</script>

